import api, { ApiResponse } from './api';

export interface RefreshSummary {
  kinds: number;
  rowsWritten: number;
}

export const activityService = {
  /** Recomputes this workspace's Activity columns now, rather than waiting for the hourly job. */
  refresh: async (): Promise<RefreshSummary> => {
    const response = await api.post<ApiResponse<RefreshSummary>>('/activity/refresh');
    return response.data.data!;
  },
};
